export const autoSubmitForm = (formHtml) => {

    const div = document.createElement("div");
    div.innerHTML = formHtml;
    document.body.appendChild(div);

    const form = div.querySelector("form");
    form.submit();
    return true;
};
